import axios from 'axios';
import crypto from 'crypto';
import request from './request';
/*
 * Login
 */
export async function accountLogin({ userId, password, autoLogin }) {
  const res = await request.post('/portal/api/auth', { userId, password, autoLogin });

  return res.status === 201 && res.data;
}

export async function checkToken() {
  return request.get('/portal/api/auth');
}

/*
 * 자동 로그인
 */
export async function doAutoLogin(data) {
  const res = await request.patch('/portal/api/auth', {
    data: { token: data },
  });
  return res;
}

export async function checkAccount(data) {
  const res = await request.post('/portal/api/auth/check-account', {
    data: { token: data },
  });
  return res;
}

/*
 * Logout
 */
export async function accountLogout() {
  return request.post('/portal/api/auth/delete');
}

export async function deleteToken() {
  return axios.post('/portal/api/auth/delete');
}

/*
 * 패스워드 변경
 */
export async function changePassword(oldPassword, newPassword) {
  const res = await request.put(`/portal/api/session/password`, { oldPassword, newPassword });
  return res.data;
}

/*
 * 패스워드 재설정 요청(변경 권한 토큰 만들고 메일 보냄)
 */
export async function requestResetPassword(userId) {
  const res = await request.post(`/portal/api/auth/request/password-reset?userId=${userId}`);
  return res.data;
}

/*
 * 토큰 확인 후 패스워드 변경
 */
export async function updatePasswordWithResetToken(token, password) {
  const res = await request.put('/portal/api/auth/update-password-with-reset-token', {
    token,
    password,
  });
  return res.data;
}

/*
 * ldap 773 옵션(비밀번호 무조건 변경해야하는 경우)
 */
export async function changePasswordFor773(user, password) {
  const res = await request.put('/portal/api/auth/change-password', {
    user,
    password,
  });
  return res.data;
}

export async function getConnHistory(groupId) {
  const res = await request.get(`/portal/api/auth/conn-history/${groupId}`);
  return res.data;
}

// 세션에서 내정보 가져오기
export async function getSessionUser() {
  const res = await request.get(`/portal/api/session/user`);
  return res;
}

export async function getRequieredProgram() {
  const res = await request.get(`/portal/api/session/required-program`);
  return res.data;
}

export async function getCustomRedirect() {
  const res = await request.get(`/portal/api/session/custom-redirect`);
  return res.data;
}

//
export async function getCustomClient() {
  const res = await request.get(`/portal/api/session/custom-client`);
  return res.data;
}

// 2factor 인증코드 생성
export async function twoFactorCodeGenerate({ channel, regenerate, loginInfo }) {
  const res = await request.post(
    `/portal/api/auth/additional-auth/generate?regenerate=${regenerate}`,
    { channel, ...loginInfo },
  );
  return res.data;
}

// 2factor 인증코드 검증
export async function twoFactorAuth({ authCode, loginInfo }) {
  const res = await request.post('/portal/api/auth/additional-auth', { authCode, ...loginInfo });
  return res;
}

export async function getRSAKey() {
  return request.get('/portal/api/auth/rsa-public-key');
}

export function encryptRSA(text, key) {
  const buffer = Buffer.from(text);
  const encrypted = crypto.publicEncrypt(key, buffer);
  return encrypted.toString('hex');
}
